<template>
  <component :is="linkType" :[linkProp]="url" class="link" :class="{
    'link--primary': variant === 'primary',
    'link--secondary': variant === 'secondary',
    'link--tertiary': variant === 'tertiary',
    'link--quiet': isQuiet,
    'link--external': external
  }" :target="computedTarget" :rel="computedRel">
    <span class="link__text">{{ text }}</span>
    <sword-icon-wuk v-if="icon" :name="icon" />
  </component>
</template>


<script>
import SwordIconWuk from '@ui-kit/components/icons/SwordIcon.vue';

export default {
  name: 'SwordLink',
  components: {
    SwordIconWuk
  },
  props: {
    href: {
      type: String,
      default: null
    },
    to: {
      type: [String, Object],
      default: null
    },
    icon: {
      type: String,
      default: null
    },
    target: {
      type: String,
      default: '_blank'
    },
    rel: {
      type: String,
      default: 'noopener noreferrer'
    },
    text: {
      type: String,
      required: true,
    },
    variant: {
      type: String,
      default: 'primary',
      validator: value => ['primary', 'secondary', 'tertiary'].includes(value)
    },
    isQuiet: {
      type: Boolean,
    },
    external: {
      type: Boolean,
    }
  },
  computed: {
    linkType() {
      return this.href ? 'a' : 'router-link';
    },
    linkProp() {
      return this.href ? 'href' : 'to';
    },
    url() {
      return this.href || this.to;
    },
    computedTarget() {
      return this.linkType === 'a' && this.target ? this.target : null;
    },
    computedRel() {
      return this.linkType === 'a' && this.computedTarget === '_blank' ? this.rel : null;
    }
  }
};
</script>

<style lang="scss" scoped>
.link {
  display: inline-flex;
  align-items: center;
  gap: 0.25rem;
  border-radius: 0.25rem;
  outline: none;
  width: fit-content;
  height: fit-content;
  text-decoration: underline;

  &__text {
    @extend %-t_medium;
    margin: 0 !important;
  }

  &--quiet {
    text-decoration: none;
    &:hover, &:focus {
      text-decoration: underline;
    }
  }

  &--primary {
    color: $color-primary-500;

    &:hover {
      color: $color-primary-600;
    }

    &:focus {
      box-shadow: 0 0 0 2px $color-grey-300;
    }
  }

  &--secondary {
    color: $color-grey-900;

    &:hover {
      color: $color-primary-600;
    }

    &:focus {
      box-shadow: 0 0 0 2px $color-grey-300;
    }
  }

  &--tertiary {
    color: $color-white;

    &:hover {
      color: $color-primary-600;
    }

    &:focus {
      box-shadow: 0 0 0 2px $color-grey-300;
    }
  }

  &--external {
    &:visited {
      color: $color-secondary-800;
    }
  }

  .sword-icon.svg-icon {
    width: 1rem;
    height: 1rem;
  }
}
</style>
